import { useState } from "react";

const FilterModal = ({ isOpen, onClose, data = [], activeTags, handleTagClick }) => {
  const [isClosing, setIsClosing] = useState(false);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose();
      setIsClosing(false);
    }, 300); // Задержка, чтобы анимация успела завершиться
  };

  const handleCheckboxChange = (value) => {
    // Обновляем теги так же, как это делается в FilterSection
    handleTagClick(value, 'material');
  };

  if (!isOpen && !isClosing) return null;

  return (
    <div className="filter-modal-overlay">
      {/* <motion.div 
        initial={{ opacity: 0, y: 50 }} 
        animate={{ opacity: isClosing ? 0 : 1, y: isClosing ? 50 : 0 }} 
        exit={{ opacity: 0, y: 50 }}
        transition={{ duration: 0.3 }}
        className="filter-modal"
      >
        <div className="filter-modal-header">
          <p className="filter-modal-header-title">Выберите </p>
          <X className="filter-modal-close-icon" onClick={handleClose} />
        </div>
        {data && data.length > 0 ? (
          data.map((size) => (
            <div key={size} className="filter-modal-option">
              <label htmlFor={size}>{size}</label>
              <input
                type="checkbox"
                className="filter-modal-checkbox"
                checked={activeTags.includes(size)}
                onChange={() => handleCheckboxChange(size)}
                id={size}
              />
            </div>
          ))
        ) : (
          <p>Нет доступных вариантов</p>
        )}
      </motion.div> */}
    </div>
  );
};

export default FilterModal;
